import { useState } from 'react';
import { OrderHistory, AdvertiserList, TransactionHistory } from '../components/advertiser';

const Advertiser = () => {
  const [viewMode, setViewMode] = useState('list'); // 'list' or 'single'
  const [selectedAdvertiser, setSelectedAdvertiser] = useState(null);

  const [name, setName] = useState('Benjamin Abraham');
  const [email, setEmail] = useState('Benjamin.abraham@gmail.com');
  const [contactNumber, setContactNumber] = useState('+1-310-555-4821');

  const handleUserClick = (advertiser) => {
    setSelectedAdvertiser(advertiser);
    setName(advertiser.name);
    setEmail(advertiser.email);
    setViewMode('single');
  };

  const handleBackToList = () => {
    setViewMode('list');
    setSelectedAdvertiser(null);
  };

  // Show list view
  if (viewMode === 'list') {
    return <AdvertiserList onUserClick={handleUserClick} />;
  }

  // Show single advertiser view
  return (
    // ----Single Advertiser Page---->>
    <div className="space-y-6">
      {/* Back Button */}
      <button
        onClick={handleBackToList}
        className="flex items-center gap-2 text-primary hover:text-hover transition-colors"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 18l-6-6 6-6"
          />
        </svg>
        <span className="text-base font-medium">Back to Advertisers</span>
      </button>
      {/* Basic Details Section */}
      <div className="bg-white rounded-lg shadow-[0px_0px_4px_#6d6d6d4a] p-6">
        <h2 className="text-xl font-medium text-black mb-6 pb-4 border-b border-gray-200">
          Basic Details
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Name Field */}
          <div className="flex flex-col gap-2">
            <label className="text-lg font-normal text-textcolor">
              Name
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="px-4 py-3 bg-[#fafafa] border border-gray-200 rounded-lg text-black font-normal text-base focus:outline-none focus:ring-2 focus:ring-primary/20"
            />
          </div>

          {/* Email Address Field */}
          <div className="flex flex-col gap-2">
            <label className="text-lg font-normal text-textcolor">
              Email Address
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="px-4 py-3 bg-[#fafafa] border border-gray-200 rounded-lg text-black font-normal text-base focus:outline-none focus:ring-2 focus:ring-primary/20"
            />
          </div>

          {/* Contact Number Field */}
          <div className="flex flex-col gap-2">
            <label className="text-lg font-normal text-textcolor">
              Contact Number
            </label>
            <input
              type="tel"
              value={contactNumber}
              onChange={(e) => setContactNumber(e.target.value)}
              className="px-4 py-3 bg-[#fafafa] border border-gray-200 rounded-lg text-black font-normal text-base focus:outline-none focus:ring-2 focus:ring-primary/20"
            />
          </div>
        </div>
      </div>

      {/* Account Summary Section */}
      <div className="bg-white rounded-lg shadow-[0px_0px_4px_#6d6d6d4a] p-6">
        <h2 className="text-xl font-medium text-black mb-6 pb-4 border-b border-gray-200">
          Account Summary
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {/* Total Orders Card */}
          <div className="bg-[#d4f4fb] rounded-lg p-6">
            <p className="text-base font-normal text-textcolor mb-2">
              Total Orders
            </p>
            <p className="text-[20px] font-medium text-black">
              12
            </p>
          </div>

          {/* Active Campaigns Card */}
          <div className="bg-[#d4f4d7] rounded-lg p-6">
            <p className="text-base font-normal text-textcolor mb-2">
              Active Campaigns
            </p>
            <p className="text-[20px] font-medium text-black">
              03
            </p>
          </div>

          {/* Total Spent Card */}
          <div className="bg-[#fde9e4] rounded-lg p-6">
            <p className="text-base font-normal text-textcolor mb-2">
              Total Spent
            </p>
            <p className="text-[20px] font-medium text-black">
              $2,480.00
            </p>
          </div>

          {/* Avg. Monthly Spend Card */}
          <div className="bg-[#e8dff5] rounded-lg p-6">
            <p className="text-base font-normal text-textcolor mb-2">
              Avg. Monthly Spend
            </p>
            <p className="text-[20px] font-medium text-black">
              $826.67
            </p>
          </div>
        </div>
      </div>

      {/* Activity Log Section */}
      <div className="bg-white rounded-lg shadow-[0px_0px_4px_#6d6d6d4a] p-6">
        <h2 className="text-xl font-medium text-black mb-6 pb-4 border-b border-gray-200">
          Activity Log
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Last Login Field */}
          <div className="flex flex-col gap-2">
            <label className="text-lg font-normal text-textcolor">
              Last Login
            </label>
            <div className="px-4 py-3 bg-white border border-gray-200 rounded-lg text-black font-normal text-base">
              27-09-2025, 10:30 AM
            </div>
          </div>

          {/* Last Order Field */}
          <div className="flex flex-col gap-2">
            <label className="text-lg font-normal text-textcolor">
              Last Order
            </label>
            <div className="px-4 py-3 bg-white border border-gray-200 rounded-lg text-black font-normal text-base">
              15-09-2025, 12:30 PM
            </div>
          </div>

          {/* Last Payment Field */}
          <div className="flex flex-col gap-2">
            <label className="text-lg font-normal text-textcolor">
              Last Payment
            </label>
            <div className="px-4 py-3 bg-white border border-gray-200 rounded-lg text-black font-normal text-base">
              15-09-2025
            </div>
          </div>
        </div>
      </div>

      {/* Order History Section */}
      <OrderHistory />

      {/* Transaction History Section */}
      <TransactionHistory />
    </div>
    // ----Single Advertiser Page Ends---->>

    // ---Main Advertiser Page Starts -->>

  );
};

export default Advertiser;
